const state = {
    examParams:{}
}

const mutations = {
    setExamParams: (state, obj) => {
        state.examParams = obj;
    }
}


export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/exam.js